import React from 'react';
import PropTypes from 'prop-types';

const Radio = ({
  icon,
  displayCheck,
  children,
  className,
  checked,
  style,
  ...rest
}) => {
  let displayClassName = 'ajaib-radio ajaib-radio-container';
  if (checked) {
    displayClassName += ' checked';
  }
  if (className) {
    displayClassName = `${displayClassName} ${className}`;
  }
  return (
    <label className={displayClassName} style={style}>
      <input type="radio" checked={checked} {...rest} />
      {children}
    </label>
  );
};

Radio.propTypes = {
  icon: PropTypes.bool,
  displayCheck: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  checked: PropTypes.bool,
};

Radio.defaultProps = {
  icon: false,
  displayCheck: false,
  className: '',
  style: null,
  checked: false,
};

export default Radio;
